import { render, staticRenderFns } from "./PlaceDashboard.vue?vue&type=template&id=6a9daf26&scoped=true"
import script from "./PlaceDashboard.vue?vue&type=script&lang=js"
export * from "./PlaceDashboard.vue?vue&type=script&lang=js"
import style0 from "./PlaceDashboard.vue?vue&type=style&index=0&id=6a9daf26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9daf26",
  null
  
)

export default component.exports